@if (isAdmin$ | async) {
  <p>({{ getPlanIdName() | async }} Plan)</p>
}
